/*
  Rejuran Cosmetics Albania - coming-soon page (brief v2).

  Reveals only. No strand, no progress dots - v2 removed both.

  Each screen fires once when 40% in view, and steps its children in via
  data-cs-step. Per-screen intervals differ (600ms on screen 1, 400ms on
  screen 2, 500ms elsewhere), so the interval is set as a custom property
  rather than hard-coded in CSS.

  No libraries.
*/
(function () {
  'use strict';

  var root = document.querySelector('[data-cs-root]');
  if (!root) return;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var screens = Array.prototype.slice.call(root.querySelectorAll('[data-cs-screen]'));
  if (!screens.length) return;

  // Per-brief stagger intervals, by screen class.
  var INTERVALS = {
    'cs-screen--hero': 520,
    'cs-screen--ampoules': 400,
  };
  var DEFAULT_INTERVAL = 500;

  function intervalFor(el) {
    for (var cls in INTERVALS) {
      if (el.classList.contains(cls)) return INTERVALS[cls];
    }
    return DEFAULT_INTERVAL;
  }

  // Seed each screen's interval and each child's step index.
  screens.forEach(function (screen) {
    screen.style.setProperty('--cs-step-ms', intervalFor(screen) + 'ms');

    var steps = screen.querySelectorAll('[data-cs-step]');
    Array.prototype.forEach.call(steps, function (el) {
      el.style.setProperty('--cs-step', el.getAttribute('data-cs-step') || 0);
    });
  });

  /* ------------------------------------------------------------- Plate */

  /*
    The plate covers the hero and the ampoules, ending where the Sea Mint
    screen begins. Measured rather than hardcoded because both screens grow
    when copy wraps.
  */
  var plateEl = root.querySelector('[data-cs-plate]');

  function sizePlate() {
    if (!plateEl) return;
    var mint = root.querySelector('.cs-screen--skin');
    // offsetTop is relative to .cs, which is position: relative.
    var h = mint && mint.offsetTop > 0 ? mint.offsetTop : root.offsetHeight;
    plateEl.style.setProperty('--cs-plate-h', h + 'px');
    return h;
  }

  /*
    Depth layers. Each element carrying data-cs-depth moves up faster than the
    page scrolls, by its depth factor - so the logo (0.62) clears the screen
    well before the bubbles (0.24), and the plate drifts slowest of all. That
    difference is the whole parallax; nothing is pinned or sticky.
  */
  var depthEls = Array.prototype.slice.call(root.querySelectorAll('[data-cs-depth]'));

  /*
    Elements whose own progress through the viewport drives an effect - the
    ampoule fill. Each gets --cs-enter, 0 -> 1, as it crosses.
  */
  var tracked = Array.prototype.slice.call(root.querySelectorAll('[data-cs-track]'));

  function clamp01(n) {
    if (!isFinite(n)) return 0;
    return n < 0 ? 0 : n > 1 ? 1 : n;
  }

  /* --------------------------------------------- Scroll progress (draw) */

  var ticking = false;

  function measure() {
    ticking = false;
    var vh = window.innerHeight || document.documentElement.clientHeight;
    var rect = root.getBoundingClientRect();
    var scrollable = rect.height - vh;
    var scrolled = -rect.top;
    var p = scrollable > 0 ? scrolled / scrollable : 1;
    p = p < 0 ? 0 : p > 1 ? 1 : p;
    root.style.setProperty('--cs-progress', p.toFixed(4));

    // The invitation has been accepted; stop showing it.
    if (scrolled > 40) root.classList.add('has-scrolled');

    // The plate drifts down slightly as the page scrolls up: classic parallax,
    // and the -6% inset on the image gives it room to move without an edge.
    if (plateEl) {
      plateEl.style.setProperty('--cs-plate-shift', (scrolled * 0.12).toFixed(2));
    }

    // Depth layers rise faster than the page, in order of their depth factor.
    for (var d = 0; d < depthEls.length; d++) {
      var depth = parseFloat(depthEls[d].getAttribute('data-cs-depth')) || 0;
      depthEls[d].style.setProperty('--cs-shift', (-scrolled * depth).toFixed(2));
    }

    // 0 when the element's top is near the bottom of the viewport, 1 once it
    // has risen to the upper quarter - so the fill completes while the
    // silhouettes are comfortably in view, not as they leave.
    for (var i = 0; i < tracked.length; i++) {
      var tr = tracked[i].getBoundingClientRect();
      var from = vh * 0.88;
      var to = vh * 0.28;
      tracked[i].style.setProperty(
        '--cs-enter',
        clamp01((from - tr.top) / (from - to)).toFixed(4)
      );
    }
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(measure);
  }

  function revealAll() {
    screens.forEach(function (s) {
      s.classList.add('is-visible');
    });
  }

  sizePlate();

  // Re-measure on resize: the plate ends at the mint screen, which moves when
  // copy reflows.
  var resizeTimer;
  window.addEventListener(
    'resize',
    function () {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(function () {
        sizePlate();
        measure();
      }, 150);
    },
    { passive: true }
  );

  if (reduceMotion || !('IntersectionObserver' in window)) {
    // Show everything rather than risk hiding content.
    revealAll();
    root.style.setProperty('--cs-progress', 1);
    tracked.forEach(function (el) {
      el.style.setProperty('--cs-enter', 1);
    });
    return;
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  measure();

  /* -------------------------------------------------------- Scroll cue */

  // It looks like a control, so it should behave like one.
  root.addEventListener('click', function (event) {
    var cue = event.target.closest('[data-cs-scroll-next]');
    if (!cue) return;
    var screen = cue.closest('[data-cs-screen]');
    var next = screen && screen.nextElementSibling;
    while (next && !next.hasAttribute('data-cs-screen')) {
      next = next.nextElementSibling;
    }
    if (!next) return;
    next.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
  });

  /* ------------------------------------------------------------- Video */

  /*
    The film autoplays muted and looping as ambient texture. Pressing the
    control turns sound on, restarts from the top and hands over to the native
    controls. When it finishes it goes back to being ambient, so the page never
    ends up sitting on a black final frame.

    It also pauses whenever it leaves the viewport - sound continuing from a
    screen the viewer has scrolled away from is the worst version of this.
  */
  var videoWraps = Array.prototype.slice.call(root.querySelectorAll('[data-cs-video]'));

  videoWraps.forEach(function (wrap) {
    var video = wrap.querySelector('video');
    var playBtn = wrap.querySelector('[data-cs-video-play]');
    if (!video) return;

    var soundOn = false;

    function toAmbient() {
      soundOn = false;
      video.muted = true;
      video.loop = true;
      video.controls = false;
      wrap.classList.remove('is-playing');
      var p = video.play();
      if (p && p.catch) p.catch(function () {});
    }

    if (playBtn) {
      playBtn.addEventListener('click', function () {
        soundOn = true;
        video.muted = false;
        video.loop = false;
        video.controls = true;
        video.currentTime = 0;
        wrap.classList.add('is-playing');

        var p = video.play();
        // Autoplay policies can still refuse; fall back rather than appear broken.
        if (p && p.catch) {
          p.catch(function () {
            toAmbient();
          });
        }
      });
    }

    video.addEventListener('ended', toAmbient);

    if ('IntersectionObserver' in window) {
      var vObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              // Only auto-resume the silent loop; never restart audio for them.
              if (!soundOn) {
                var p = video.play();
                if (p && p.catch) p.catch(function () {});
              }
            } else {
              video.pause();
              if (soundOn) toAmbient();
            }
          });
        },
        { threshold: 0.25 }
      );
      vObserver.observe(wrap);
    }
  });

  /* ---------------------------------------------------------- Count up */

  /*
    Counts a number from zero when its screen arrives. The finished value is
    already in the HTML, so without JS - or for a screen reader reading before
    the animation runs - the line still says what it means. We only reset to
    zero once we know we can animate.

    Delayed to line up with that line's staggered reveal, so the number is
    counting while the line fades in rather than before it appears.
  */
  function countUp(el) {
    var target = parseFloat(el.getAttribute('data-cs-count'));
    if (!isFinite(target) || target <= 0) return;

    var stepEl = el.closest('[data-cs-step]');
    var step = (stepEl && parseFloat(stepEl.getAttribute('data-cs-step'))) || 0;
    var interval = intervalFor(el.closest('[data-cs-screen]') || root) || 400;

    // How long the line takes to fade in, from the CSS custom property.
    var reveal =
      parseFloat(getComputedStyle(root).getPropertyValue('--cs-reveal-ms')) || 500;

    /*
      Start AFTER the line is readable, not as it begins fading in. Previously
      both started together, so with a 500ms fade and a 1400ms count the number
      was already at 7 by the time the text was visible - it read as static.
    */
    var delay = step * interval + reveal;

    /*
      Two decimals while in flight. Counting to 10 in whole numbers has only
      eleven distinct values, so however it is timed it reads as a few steps
      rather than motion. Hundredths give ~1000, which is what makes it move.

      Eased rather than linear: with decimals ticking throughout there is plenty
      of movement late on, so an ease-out settles onto the final figure instead
      of stopping dead.
    */
    var DURATION = Math.max(1600, Math.min(target * 240, 4000));
    var DEC_FADE = 160; // decimals fade before the slot collapses

    var intEl = document.createElement('span');
    var decEl = document.createElement('span');
    decEl.className = 'cs-count__dec';
    intEl.textContent = '0';
    decEl.textContent = '.00';

    el.textContent = '';
    el.appendChild(intEl);
    el.appendChild(decEl);
    el.classList.add('is-counting');

    window.setTimeout(function () {
      var start = null;
      function frame(now) {
        if (start === null) start = now;
        var t = Math.min((now - start) / DURATION, 1);
        var eased = 1 - Math.pow(1 - t, 3);
        var v = eased * target;
        var whole = Math.floor(v);
        var cents = Math.floor((v - whole) * 100);

        intEl.textContent = whole.toString();
        decEl.textContent = '.' + (cents < 10 ? '0' : '') + cents;

        if (t < 1) {
          window.requestAnimationFrame(frame);
          return;
        }

        /*
          Settle. "10.00" -> "10" loses three characters, which would jerk the
          centred line sideways in a single frame. So: fade the decimals out
          first, then drop them and let the reserved slot shrink on a CSS
          transition, so the rest of the line slides rather than jumps.
        */
        intEl.textContent = target.toString();
        el.classList.add('is-settling');

        window.setTimeout(function () {
          if (decEl.parentNode) decEl.parentNode.removeChild(decEl);
          el.classList.remove('is-counting', 'is-settling');
        }, DEC_FADE);
      }
      window.requestAnimationFrame(frame);
    }, delay);
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');

        var counters = entry.target.querySelectorAll('[data-cs-count]');
        Array.prototype.forEach.call(counters, countUp);

        observer.unobserve(entry.target); // nothing animates twice
      });
    },
    { threshold: 0.4 } // v2: triggered when the screen is 40% in view
  );

  screens.forEach(function (screen) {
    // Screen 1 animates on load rather than on scroll - it is already in view.
    if (screen.hasAttribute('data-cs-onload')) {
      window.requestAnimationFrame(function () {
        screen.classList.add('is-visible');
      });
      return;
    }
    observer.observe(screen);
  });
})();
